<template>
  <div class="app-container" style="display: flex;flex-direction: column;">
    <el-card style="width: 100%;margin-bottom: 50px;padding-bottom: 20px;">
      <h4>个人信息</h4>
      <div style="display: flex;">
        <el-form ref="form" :model="form" label-width="25%" style="width: 100%;display: flex;" :rules="ruleForm">
          <div style="width: 40%;">
            <el-row type="flex" justify="center">
              <el-col :span="24">
                <el-form-item label="用户名" prop="loginName">
                  <el-input
                    v-model="form.loginName"
                    placeholder="请输入"
                    clearable
                    style="width: 80%;"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" justify="center">
              <el-col :span="24">
                <el-form-item label="姓名" prop="realName">
                  <el-input
                    v-model="form.realName"
                    placeholder="请输入"
                    clearable
                    style="width: 80%;"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" justify="center">
              <el-col :span="24">
                <el-form-item label="手机号" prop="mobile">
                  <el-input
                    v-model="form.mobile"
                    placeholder="请输入"
                    clearable
                    style="width: 80%;"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" justify="center">
              <el-col :span="24">
                <el-form-item label="性别" prop="gender">
                  <el-input
                    v-model="form.gender"
                    placeholder="请输入"
                    clearable
                    style="width: 80%;"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" justify="center">
              <el-col :span="24">
                <el-form-item label="出生日期" prop="birthDate">
                  <el-date-picker
                    v-model="form.birthDate"
                    type="date"
                    style="width: 80%;"
                    value-format="YYYY-mm-dd"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" justify="center">
              <el-col :span="24">
                <el-form-item label="电子邮箱" prop="email">
                  <el-input
                    v-model="form.email"
                    placeholder="请输入"
                    clearable
                    style="width:80%;"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" justify="center">
              <el-col :span="24">
                <el-form-item label="所属科室" prop="orgName">
                  <el-input
                    v-model="form.orgName"
                    placeholder="请输入"
                    clearable
                    style="width:80%;"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" justify="center">
              <el-col :span="24">
                <el-form-item label="民族" prop="nationName">
                  <el-input
                    v-model="form.nationName"
                    placeholder="请输入"
                    clearable
                    style="width:80%;"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" justify="center">
              <el-col :span="24">
                <el-form-item label="政治面貌" prop="politicalLandscapeName">
                  <el-input
                    v-model="form.politicalLandscapeName"
                    placeholder="请输入"
                    clearable
                    style="width:80%;"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" justify="center">
              <el-col :span="24">
                <el-form-item label="参加工作时间" prop="joiningDateStr">
                  <el-date-picker
                    v-model="form.joiningDateStr"
                    type="date"
                    style="width: 80%;"
                    disabled
                    value-format="YYYY-mm-dd"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" justify="center">
              <el-col :span="24">
                <el-form-item label="现获得职称" prop="currentTitle">
                  <el-input
                    v-model="form.currentTitle"
                    placeholder="请输入"
                    clearable
                    style="width:80%;"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" justify="center">
              <el-col :span="24">
                <el-form-item label="现担任职务" prop="currentPosition">
                  <el-input
                    v-model="form.currentPosition"
                    placeholder="请输入"
                    clearable
                    style="width:80%;"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" justify="center">
              <el-col :span="24">
                <el-form-item label="身份证号" prop="idNo">
                  <el-input
                    v-model="form.idNo"
                    placeholder="请输入"
                    clearable
                    style="width:80%;"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" justify="center">
              <el-col :span="24">
                <el-form-item label="持续评价能力" prop="continuousAbilityEvaluation">
                  <el-input
                    v-model="form.continuousAbilityEvaluation"
                    type="textarea"
                    placeholder="请输入"
                    clearable
                    style="width:80%;"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div style="width: 60%;">
            <el-row type="flex" justify="start">
              <el-col :span="24">
                <el-form-item label="上传电子签" label-width="15%" prop="continuousAbilityEvaluation">
                  <el-button type="primary" size="small" style="margin-bottom: 10px;" @click="handleStartSign">开始签字</el-button>
                  <el-upload
                    :file-list="fileList"
                    list-type="picture-card"
                    :on-change="getFile"
                    :on-remove="onRemove"
                    :on-exceed="handleExceed"
                    :accept="'.jpg,.png,.gif'"
                    :limit="1"
                    :before-upload="beforeUpload"
                    class="upload-demo mt10"
                    action=""
                    :http-request="uploadChange"
                    @click.native="upload"
                  >
                    <i slot="default" class="el-icon-plus" />
                    <div slot="tip" style="width: 100%" class="el-upload__tip">
                      建议上传图片大小:小于100kb，支持扩展名:.png、 .gif、 .jpg
                    </div>
                  </el-upload>
                  <p style="color: red;">提示：请在干净白纸签字后拍照，需要处理成PNG透明签名图片，再上传PNG透明签名图。</p>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </div>
    </el-card>
    <el-card class="footer">
      <el-button size="small" @click="cancel">关闭</el-button>
      <el-button type="primary" size="small" @click="save">保存</el-button>
    </el-card>
  </div>
</template>
<script>
import { personalInfo, updatePersonalInfo, saveUserSignatrue } from '@/api/personalCenter'
import { DoGWQ_SignName } from '@/api/sdk'
import { emitter } from '@/api/message'
import { logger } from 'runjs/lib/common'
export default {
  props: {
    /** 在布局弹窗中展示时设为 true，关闭不再依赖路由 */
    embedInDialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      pageId: '',
      disable: false,
      employeeId: '',
      fileList: [],
      form: {
      },
      ruleForm: {
        mobile: [{ required: true, message: '请输入手机号', trigger: 'blur' }]
        // email: [{ required: true, message: '请输入电子邮箱', trigger: 'blur' }]
      },
      signNum: 0,
      _signListenerAttached: false
    }
  },
  created() {
    this.onSignBoardMessage = (data) => {
      if (data.ret === 0) {
        this.fileList = [{ url: 'data:image/jpeg;base64,' + data.base64 }]
        this.form.signatrueImg = data.base64
        if (this.signNum === 1) {
          this.$message.success('签名成功！')
          this.signNum = 0
        }
      } else {
        this.$message.error('签名失败！')
      }
    }
  },
  mounted() {
    this.pageId = this.$route.params.pageId || sessionStorage.getItem('pageId')
    personalInfo().then(res => {
      if (res.code === '200') {
        this.form = res.data
        this.fileList = res.data.signatrueImg ? [{ url: 'data:image/jpeg;base64,' + res.data.signatrueImg }] : []
      } else {
        this.$message({
          type: 'error',
          message: res.msg
        })
      }
    })
  },
  beforeDestroy() {
    // 组件销毁前移除事件监听器
    this.removeSocketListeners()
  },
  methods: {
    // 取消
    cancel() {
      if (this.embedInDialog) {
        this.$emit('close')
        return
      }
      this.$store.dispatch('tagsView/delView', this.$route)
      this.$router.go(-1)
    },
    // 保存
    save() {
      if (this.form.signatrueImg) {
        saveUserSignatrue({ signatrue: this.form.signatrueImg.slice(this.form.signatrueImg.indexOf(',') + 1) }).then(res => {
          if (res.code === '200') {
            this.update()
          } else {
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      } else {
        this.update()
      }
    },
    update() {
      updatePersonalInfo(this.form).then(res => {
        if (res.code === '200') {
          this.$message({
            type: 'success',
            message: res.msg
          })
          // this.$router.push({ name: 'dashboard' })
          this.cancel()
        } else {
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })
    },
    // 开始签字（依赖本机捷宇/签字板客户端 WebSocket 127.0.0.1:1919）
    handleStartSign() {
      this.setupSocketListeners()
      this.signNum += 1
      const ok = DoGWQ_SignName({
        XmlPath: 'C:\\Users\\Public\\hw.xml',
        SignNamePath: 'C:\\Users\\Public\\signname.png'
      })
      if (!ok) {
        this.signNum = Math.max(0, this.signNum - 1)
        this.$message.warning(
          '未连接本机签字服务（需本机程序监听127.0.0.1:1919）。请安装并启动捷宇等配套签字客户端后再试；若使用 Mac 或无客户端环境，请改用下方上传签名图片。'
        )
      }
    },
    // 监听捷宇 socket 返回数据（只注册一次，避免重复回调）
    setupSocketListeners() {
      if (this._signListenerAttached) return
      emitter.on('start-sign', this.onSignBoardMessage)
      this._signListenerAttached = true
    },
    removeSocketListeners() {
      if (this._signListenerAttached && this.onSignBoardMessage) {
        emitter.off('start-sign', this.onSignBoardMessage)
        this._signListenerAttached = false
      }
    },
    handleChange(file, fileList) {
      this.fileList = fileList.slice(-3)
    },
    onRemove(file, fileList) {
      if (fileList.length == 0) {
        this.form.signatrueImg = ''
      }
    },
    handleExceed(file, fileList) {
      this.$message.warning('请最多上传一个文件')
    },
    // 判断上传文件类型及大小
    beforeUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = testmsg === 'jpg'
      const extension2 = testmsg === 'png'
      const extension3 = testmsg === 'gif'
      const isLt2M = file.size / 1024 < 100
      if (!extension && !extension2 && !extension3) {
        this.$message({
          message: '上传文件只能是 jpg、png、gif格式!',
          type: 'error'
        })
      }
      // 也可以在这里增加文件大小限制
      if (!isLt2M) {
        this.$message({
          message: '上传图片大小不能超过 100kb!',
          type: 'error'
        })
      }
      return (extension || extension2 || extension3) && isLt2M
      // return extension || extension2
    },
    // 上传
    uploadChange(fileObj) {},

    // 上传取当前点击的上传索引
    upload(file) {
      // console.log(file,222)
      // this.sort = item.sort;
    },

    getFile(file, fileList) {
      this.getBase64(file.raw).then((res) => {
        this.form.signatrueImg = res
      })
    },
    getBase64(file) {
      return new Promise(function(resolve, reject) {
        const reader = new FileReader()
        let imgResult = ''
        reader.readAsDataURL(file)
        reader.onload = function() {
          imgResult = reader.result
        }
        reader.onerror = function(error) {
          reject(error)
        }
        reader.onloadend = function() {
          resolve(imgResult)
        }
      })
    }
  }
}
</script>
  <style lang="scss" scoped>
  .el-range-input {
    font-size: 13px !important;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  </style>

